module.exports = "/images/vendor/flag-icon-css/flags/4x3/pn.svg?c4a2e49ffb6e0dc37c7e4f372b634eb8";